export function flashPanel(id) {
	const el = document.querySelector(`[data-panel="${id}"]`)
	if (!el) return
	el.animate(
		[
			{ filter: 'brightness(1.2)', background: 'var(--deep-25)', offset: 0 },
			{ filter: 'brightness(1.5)', background: 'var(--deep-25)', offset: 0.3 },
			{ filter: 'brightness(1)', background: 'transparent', offset: 1 },
		],
		{ duration: 700, easing: 'ease-out' }
	)
}
